import { use, useContext, useState, useEffect } from 'react';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';

import LabResultsByQualityTable from './LabResultByQualityTable';
import LabResultsByTimeTable from './LabResultsByTimeTable';
import ManageLabResults from './ManageLabResults';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import { UserPreferencesContext } from '../../../Contexts/UserPreferencesContext';

export type LabResultsColumnType = "SampleTime"
    | "AuthorisedTime"
    | "BatchName"
    | "UnitArea"
    | "Quality"
    | "Analysis"
    | "Component"
    | "SamplingPoint"
    | "SMSampleId"
    | "Value"
    | "Units"
    | "Usage"
    | "Grade"
    | "Lot"

export interface LabResultsSectionProps {
    isRailCarSite?: boolean,
    showSampleGrade?: boolean,
    customColumns?: LabResultsColumnType[]
}

const LabResultsSection = function LabResultsSection({ isRailCarSite = false, showSampleGrade = false, customColumns = undefined }: LabResultsSectionProps) {

    const { lotDetail: { summary: { lotNumber }, excludeLabResults: excludeSampleIds, includeLabResults: includeSampleIds, labResults }, getLotDetail } = useContext(LotDetailContext);

    const { userPreferences, saveUserPreference } = use(UserPreferencesContext);
    const [showByTime, setShowByTime] = useState(false);

    useEffect(() => {
        setShowByTime(!!userPreferences?.lotDetail?.showLabResultByTime);
    }, [userPreferences?.lotDetail?.showLabResultByTime]);

    const ToggleShowByQualityOrTime = () => {
        const newValue = !showByTime;
        setShowByTime(newValue);
        saveUserPreference("lotDetail.showLabResultByTime", newValue);
    }

    const actions =
        <div className="d-flex">
            <OverlayTrigger overlay={<Tooltip>{showByTime ? "Show results by quality" : "Show results by time"}</Tooltip>} popperConfig={{}}>
                <Button className='me-2'>
                    <FontAwesomeIcon icon={faArrowsRotate} onClick={ToggleShowByQualityOrTime} />
                </Button>
            </OverlayTrigger>

            <ManageLabResults lotNumber={lotNumber} labResults={labResults} includeSampleIds={includeSampleIds} excludeSampleIds={excludeSampleIds} getLotDetail={getLotDetail} />
        </div>;

    return showByTime
        ? <LabResultsByTimeTable isRailCarSite={isRailCarSite} showSampleGrade={showSampleGrade}>{actions}</LabResultsByTimeTable>
        : <LabResultsByQualityTable isRailCarSite={isRailCarSite} showSampleGrade={showSampleGrade} customColumns={customColumns}>{actions}</LabResultsByQualityTable>
};

export default LabResultsSection;